<script>
  import options from './ProductSpot.options'
  export default options
</script>

<template>

    <article v-if="productDataSet" class="nlx-product-spot" :class="ambienceToggleModifier">

        <a :href="productDataSet.productPageUrl" class="nlx-product-spot__click-layer" @mouseover="displayEnvironmentImage" @touchstart="displayEnvironmentImage"></a>

        <section v-if="productDataSet.variantSku" class="nlx-product-spot__product-display">

            <div class="nlx-product-spot__environment-image" :class="environmentImageDisplayClass">
                <img v-if="hoverShotAvailable" :src="productDataSet.hoverShotUrls[0]" alt="" @mouseleave="displayEnvironmentImage">
                <div class="nlx-product-spot__environment-image__hide-when-mouseover"></div>
            </div>

            <ul class="nlx-product-spot__label-list" >
                <li v-for="(label,labelIndex) in productLabels" :key="labelIndex"><span class="nlx-product-spot__label" :style="{ backgroundColor: label.colorCode}">{{label.value}}</span></li>
            </ul>

            <template v-if="userIsLoggedIn && showRrp">
                <InStockLabel
                    :inStock="productDataSet.inStock.inStock"
                    :formatted="productDataSet.inStock.formatted"
                    :formattedAvailableDate="productDataSet.inStock.formattedAvailableDate"
                />
            </template>

            <div class="nlx-product-spot__image-container" >
                <img :src="productDataSet.packShotUrls[0]" alt="">
            </div>

            <div v-if="showRrp" class="nlx-product-spot__price">
                <span class="nlx-product-spot__price__price-line" :style="priceColor ? { color: priceColor, fontWeight: 'bold'} : {}">{{productDataSet.price.formatted}}</span>
                <template v-if="userIsLoggedIn">
                    <span class="nlx-product-spot__price__vat-line">{{productDataSet.taxLabel}}</span>
                </template>
            </div>

            <div class="nlx-product-spot__add-to-cart" :class="{'nlx-product-spot__add-to-cart--logged-out':!userIsLoggedIn}">
                <template v-if="userIsLoggedIn">
                    <cart-button
                        :collisize="productDataSet.colliLabel.colliSize"
                        :productid="productDataSet.productSku"
                        :variantsku="productDataSet.variantSku"
                        :productData="productDataSet"
                        :isParentComponentBasket="false"
                    ></cart-button>
                    <p class="nlx-product-spot__add-to-cart__colli-size">{{productData.colliLabel.formatted}}</p>
                </template>
            </div>

        </section>

        <section v-if="productDataSet.brand" class="nlx-product-spot__product-text">
            <p class="nlx-product-spot__product-text__brand">{{productDataSet.brand[0]}}</p>
            <p class="nlx-product-spot__product-text__product-name">{{productDataSet.displayName}}</p>
            <p class="nlx-product-spot__product-text__item-name">{{getLabel('itemNo')}} {{productDataSet.variantSku}}</p>
        </section>

    </article>

</template>
